<router-outlet *ngIf="loadingState === 'success'"></router-outlet>

<div class="load-container h-100" *ngIf="loadingState === 'loading'">
  <svg class="spinner" viewBox="0 0 50 50">
    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
  </svg>
</div>

<auex-bootstrap-error *ngIf="loadingState === 'error'"></auex-bootstrap-error>
